export default __webpack_public_path__ + "static/media/backpageBluesofa.87e30ee5.jpg";